module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v(_vm._s(_vm.text.title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "show": false
    }
  })], 1), _vm._v(" "), (_vm.step === 'to_auth') ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.text.intro))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('group', [_c('x-input', {
    attrs: {
      "title": "Email",
      "type": "email",
      "is-type": "email",
      "placeholder": "请输入登录用Email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "密码",
      "type": "password",
      "placeholder": "请在此处输入"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }, [_vm._v(_vm._s(_vm.password))])], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cells__title alert-error"
  }, [_vm._v(_vm._s(_vm.errorInfo.auth))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "25px"
    }
  }, [_c('flexbox', [_c('flexbox-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newRegister),
      expression: "!newRegister"
    }]
  }, [_c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('links')
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('flexbox-item', [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.doAuth($event)
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step === 'to_link') ? _c('div', [_c('group', {
    attrs: {
      "title": "验证成功，以下是OctoMaster用户信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "用户名",
      "value": _vm.username
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "姓名",
      "value": _vm.fullname
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "用户类型",
      "value": _vm.usertype
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "请填写以下信息完成关联设置"
    }
  }, [_c('popup-radio', {
    attrs: {
      "title": "你是以上用户的",
      "options": _vm.relationOptions
    },
    model: {
      value: (_vm.relation),
      callback: function($$v) {
        _vm.relation = $$v
      },
      expression: "relation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cells__title alert-error"
  }, [_vm._v(_vm._s(_vm.errorInfo.link))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "25px"
    }
  }, [_c('flexbox', [_c('flexbox-item', [_c('x-button', {
    attrs: {
      "type": "default"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gotoAuth(!(!_vm.errorInfo.link))
      }
    }
  }, [_vm._v("上一步")])], 1), _vm._v(" "), _c('flexbox-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errorInfo.link),
      expression: "!errorInfo.link"
    }]
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.doLink($event)
      }
    }
  }, [_vm._v("下一步")])], 1), _vm._v(" "), _c('flexbox-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorInfo.link),
      expression: "errorInfo.link"
    }]
  }, [_c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step === 'to_confirm') ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('p', [_vm._v("你现已以" + _vm._s(_vm._(_vm.relation)) + "的身份关联了OctoMaster" + _vm._s(_vm.usertype) + "帐号" + _vm._s(_vm.fullname) + "，现在就可以开始使用了")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "25px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirm($event)
      }
    }
  }, [_vm._v("好的")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("请输入OctoMaster登录用的Email和密码用以验证将要关联的用户。"), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(此页面由OctoMaster提供，无须担心微信的安全提示)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1714d36"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 575
// module chunks = 1